import React from 'react';
import logo from 'assets/images/PPSC-Logo.png';

const Logo = () => <img src={logo} alt="PPSC" width="45" />;

export default Logo;
